import { axios } from '../utils/axios';

export type SupportBoardUserType = {
  helpCenterUserId: number;
  helpCenterToken: string;
};

export async function getSupportBoardId(): Promise<SupportBoardUserType> {
  const { data } = await axios.get<SupportBoardUserType>('help-center/token');
  return data;
}

export * as SupportRequests from './support';
